export const JOURNEY = '[Journey]';

export const GET_JOURNEY_SAGA = `${JOURNEY} GET_JOURNEY_SAGA`;
export const SET_JOURNEY = `${JOURNEY} SET_JOURNEY`;
